'use strict';

var $ = jQuery;

// TODO: Fix third party ajax request issue and uncomment this
/*

$.ajaxSetup({
    headers:
        {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}
});

*/

var _init = {
	init: function () {
		_init.stepsFunc();
		_init.vinDecoder();
		_init.sellAgree();
		//_init.goToCar();
		_init.stepForm();
		_init.starRating();
		_init.menuOpen();
		_init.overallCondition();
		_init.innerSlider();
		_init.buyItForm();
	},


	//Slider on the inner car page
	innerSlider: function () {
		if (typeof $.fn.owlCarousel !== 'function') {
			return;
		}
		var sliderID  = "inner-slider";
		var linksID   = "inner-links";
		var hashName  = "item_"; //+ index
		var linkClass = "active";
		var gallery   = $("#" + sliderID);
		var hashBlock = $("#" + linksID);

		if (!gallery.length) {
			return;
		}

		var loop = false;
		var autoplay = false;
		var smallDevice = 480;

		if(document.body.offsetWidth <= smallDevice) {
			loop = true;
			autoplay = true;
		}

		addHash();

		gallery.owlCarousel({
			items: 1,
			URLhashListener: true,
			startPosition: 'URLHash',
			loop: loop,
			dots: true
		}).on('changed.owl.carousel', addActiveLink);

		//hash (navigation)
		function addHash() {
			$.each(gallery.children(), function(index) {
				let item = $(this);
				let hash = hashName + index;
				let src  = item.attr("src");

				//add data-hash to images
				item.attr("data-hash", hash);

				//add links
				$("<a/>", {
					class: "gallery-preview__link",
					href: "#" + hash,
					style: "background-image: url('" + src + "');"
				}).appendTo(hashBlock)
				  .wrap("<li></li>");
			});

			//add a class "active" to first link
			$.each(hashBlock.find("a"), function() {
				var link = $(this);
				var urlString = window.location.href;

				if(link.attr("href") === ("#" + urlString.split('#')[1])) {
					link.addClass(linkClass);
				}
			});
		};

		
		//add a class "active" to the link
		function addActiveLink(el) {
			var index = el.item.index;
			var href  = "#" + hashName + index;

			$.each(hashBlock.find("a"), function() {
				let link = $(this);

				if(link.attr("href") === href) link.addClass(linkClass);
				else link.removeClass(linkClass);
			});
		};

		//preview list
		addPreview();
		function addPreview() {
			var lis = hashBlock.children();
			var liWidth;
			var margin = 8;
			var coutn = 5; //max preview number

			//add width
			if(lis.length >= coutn) {
				liWidth = ($(".gallery-preview").innerWidth() / coutn) - margin;
			} else {
				liWidth = ($(".gallery-preview").innerWidth() / lis.length) - margin;
			}
			$.each(lis, function() {
				let li = $(this);
				li.attr("style", "width: " + liWidth + "px;");
			});

			//add arrows
			if(lis.length > coutn) {
				$("<span />", {
					id: "prevBtn",
					class: "gallery-preview__arrow_prev fa fa-angle-left disabled"
				}).appendTo($("#inner-previews"));
				$("<span />", {
					id: "nextBtn",
					class: "gallery-preview__arrow_next fa fa-angle-right"
				}).appendTo($("#inner-previews"));
			}

			//event
			var position = 0; //the current shift to the left
			var shift = liWidth + 10;
			var positionMax = 0;
			var positionMin = -((lis.length - coutn) * shift);
			
			hashBlock.css("transition", "all 0.3s ease-in 0s");
			
			$("#prevBtn").click(function() {
				$(this).removeClass("disabled");
				position += shift;
				if(position !== positionMin) {
					$("#nextBtn").removeClass("disabled");
				}
				if(position > positionMax) {
					position = positionMax;
					$(this).addClass("disabled");
				}
				hashBlock.css("margin-left", position + "px");
			});

			$("#nextBtn").click(function() {
				$(this).removeClass("disabled");
				position -= shift;
				if(position !== positionMax) {
					$("#prevBtn").removeClass("disabled");
				}
				if( position <= positionMin ) {
					position = positionMin;
					$(this).addClass("disabled");
				}
				hashBlock.css("margin-left", position + 'px');
			});
			
		};
		
		//to center the item
		toCenter();
		window.addEventListener("resize", toCenter);
		function toCenter() {
			if (document.getElementById(sliderID)) {
				var items = document.getElementById(sliderID).getElementsByClassName("owl-item");

				for (let i = 0; i < items.length; i++) {
					let itemHeight = items[i].clientHeight;
					let parentHeight = items[i].parentElement.clientHeight;

					if (parentHeight > itemHeight) {
						items[i].style.marginTop = ((parentHeight - itemHeight) / 2) + "px";
					}
				}
			}
		};

	},


	overallCondition: function () {
		var link = $('.overallCondition a');
		link.parent().next().each(function () {
			$(this).hide();
		});
		link.on('click', function (e) {
			e.preventDefault();
			$(this).parent().next().slideToggle();
		});
	},


	menuOpen: function () {
		var btn = $('#btn-menu'),
			menu = $('#nav');
		btn.on('click', function (e) {
			e.preventDefault();
			menu.slideToggle();
			$(this).children('i').toggleClass('fa-bars fa-times');
		});
	},


	starRating: function () {
		if (typeof $.fn.rateYo !== 'function') {
			return;
		}
		var stars = $('.star-rating');

		stars.next('input').hide();

		stars.each(function () {
			$(this).rateYo({
				rating: $(this).next('input').val(),
				starWidth: "30px",
				ratedFill: "#f55822",
				normalFill: "#eaeaea",
				fullStar: true,
				onSet: function (rating, rateYoInstance) {
					$(this).next('input').val(rating);
				},
				starSvg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"/></svg>'
			}).on("rateyo.change", function (e, data) {
				var rating = data.rating,
					text = $(this).attr('data-step-' + rating);
				if (rating == 0) {
					$(this).next().next('span').text('\u00A0');
				} else {
					$(this).next().next('span').text(text);
				};
			});
		});
	},

	// Form on the pages Create and Edit
	stepForm: function () {
		var form = $('#step-form'),
			input = $('#step-form .field-group .field-1 input'),
			hideGroup = $('#step-form .field-group .field-2');

		hideGroup.each(function () {
			$(this).hide();
		});

		input.each(function() {
			toOpen($(this));
		});

		input.on('change', function () {

			if ($(this).attr('type') == 'checkbox') {
				var next = $(this).parent().next();
				if ($(this).is(":not(:checked)")) {
					next.hide();
					next.find('input').prop('required', true);
				} else {
					next.show();
					next.find('input').prop('required', true);
				};
			} else if ($(this).attr('type') == 'radio') {
				var l = $(this).attr('id').charAt(0),
					next = $(this).parent().next();
				if (l == 'y') {
					next.show();
					next.find('input:first').prop('required', true);
					next.find('input').each(function () {
						$(this).on('change', function () {
							var i = $(this).parent().find('input:checked').length;
							if (i == 0) {
								$(this).parent().find('input:first').prop('required', true);
							} else {
								$(this).parent().find('input:first').prop('required', false);
							};
						});
					});
				} else {
					next.hide();
					next.find('input').each(function () {
						$(this).prop('required', false).prop('checked', false);
						$(this).removeAttr("checked");
					});
				};
			};
			
		});

		//to open inputs
		function toOpen(el) {
			var next = el.parent().next();

			if(el.is(":checked")) {
				//console.log(el.attr('type') + " " + el.attr('id') + " checked");

				if(el.attr('type') == 'checkbox') showBlock();

				if(el.attr('type') == 'radio' && el.attr('value') == '1') showBlock();
				
			}

			function showBlock() {
				next.show();
				next.find('input').prop('required', true);
			}
		}

	},

	prevStep: function() {
		$("a[href=#previous]").css( "display", "block");
	},


	/*goToCar: function () {
		var input = $('#gotocar input'),
			form = $('#gotocar'),
			link = $('#gotocar a');

		form.keydown(function(event){
			event = event || window.event;
			
			if(event.keyCode == 13) {
				event.preventDefault();

				go();
		  	}
		});

		link.click(function (e) {
			e.preventDefault();

			go();
		});

		function go() {
			if (input.val()) {
				input.removeClass('empty-field');
				link.attr('href', 'public/' + input.val());

				document.getElementById("gotocar").addEventListener("submit", function(event) {
					event = event || window.event;
					event.preventDefault();
				});

				var url = document.getElementById("go").href;
				$.get(url)
					.success(function() {
						window.location = url;
					})
					.error(function() {
						var err = $("#codeError");
						err.text("The code does not exist.");
					});

				console.log(url);
			} else {
				input.addClass('empty-field');
			};
		}
	},*/


	sellAgree: function () {
		$('#sell-page-1 button').on('click', function () {
			$('#sell-page-1').slideUp();
			$('#sell-page-2').slideDown();

			$(document).scrollTop(0);
		});
	},


	vinDecoder: function () {
		//form VIN elements
		var form     = $('#step-form'),
			vinBtn   = $('#vin-form-btn'),
			vinBtnD  = $('#vin-form-btn-double'),
			vinInp   = $('#vin-form-input'),
			vinStep  = $('#sell-page-2'),
			vinWrap  = $('#vin-form-input-wrap'),
			vinAgree = $('#sell-page-3'),
			vinNext  = $('#vinNext'),
			vinAgain = $('#vinAgain'),
			vinError = $('#vinError');
		//hidden fields 
		var	vinNone   = $("#vin-form-novin"),
			vinBrand  = $("#car-brand-input"), // $("#pre-brand"),
			vinYear   = $("#car-year-input"),  // $("#pre-year"),
			vinModel  = $("#car-model-input"), // $("#pre-model"),
			vinFields = vinNone.next(),
			vinFieldsError = $('#vinError2');
		var modelText = $("#car-model-input option:selected").text(),
			brandText = $("#car-brand-input option:selected").text();
		//DOM-elements of the result
		var inputMake      = $('#vin-form-input-wrap > input[name=make_entry_id]'),
			inputModelYear = $('#vin-form-input-wrap > input[name=year]'),
			inputModel     = $('#vin-form-input-wrap > input[name=model_entry_id]'),
			inputVin       = $('#vin'),
			inputWrap      = $('#vin-form-input-wrap'),
			inputTrim      = $('#trim'),
			inputTrim2     = $('input[name="trim_from_vin"]'),
			spanVin        = $('#span-vin'),
			spanModelYear  = $('#span-modelYear'),
			spanMake       = $('#span-make'),
			spanModel      = $('#span-model'),
			spanError      = $('#span-error'),
			trimBlock      = $('#trim-block'),
			trimWrap       = $('#trim-wrap'),
			transSelect    = $("select[name=mech_transmission]");
		var successfully   = $("#successfully"); // title "We've successfully identified your vehicle!"
		//variables with results
		var modelYear, //year
			make,      //brand
			model,     //model
			vin,       //VIN-code
			trim,      //trim
			trim2,     //trim2
			transmiss; //transmission, "Manual" or "Automatic"

		//click on Submit
		$(vinBtn).on('click', function () {
			if (!vinInp.val()) {
				//vinInp.addClass('empty-field');
				//vinError.show();

				if( !vinYear.val() || !vinBrand.val() || !vinModel.val() ) {
					vinInp.addClass('empty-field');
					vinError.show();
					vinFieldsError.show();
				} else {
					vinFieldsError.hide();
					vinInp.removeClass('empty-field');
					vinError.hide();

					// text data from selects
					make      = vinBrand.children("option:selected").text();
					modelYear =	vinYear.children("option:selected").text();
					model     = vinModel.children("option:selected").text();

					inputMake.val(vinBrand.val());
					inputModelYear.val(vinYear.val());
					inputModel.val(vinModel.val());

					spanMake.html(make + '\u00A0');
					spanModelYear.html(modelYear + '\u00A0');
					spanModel.html(model + '\u00A0');
					spanVin.parent().hide();

					vinNext.prop( "disabled", false );

					vinAgree.slideDown();
					vinStep.slideUp();

					$(document).scrollTop($("header").height());
				}

				if(!vinYear.val()) vinYear.addClass('empty-field');
				else vinYear.removeClass('empty-field');

				if(!vinBrand.val()) vinBrand.addClass('empty-field');
				else vinBrand.removeClass('empty-field');

				if(!vinModel.val()) vinModel.addClass('empty-field');
				else vinModel.removeClass('empty-field');

			// if VIN-code
			} else {
				$(this).children('img').show();
				vinInp.removeClass('empty-field');
				vinError.hide();

				vin = vinInp.val();

				$.ajax({
					url: "https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVINValuesBatch/",
					method: "POST",
					data: { format: "json", data: vin },
					dataType: "json",
                    success: function (result) {
						console.log('------------------------------------');
						console.log("result: ");
						console.log(result);
						console.log('------------------------------------');

						modelYear = result.Results[0].ModelYear;
						make = result.Results[0].Make;
						model = result.Results[0].Model;
						vin = result.Results[0].VIN;
						trim = result.Results[0].Trim;
						trim2 = result.Results[0].Trim2;
						transmiss = result.Results[0].TransmissionStyle; //"Manual" or Automatic

						if (trim) {
							// model = model + ' ' + trim;
							inputTrim.val(trim);
							inputTrim2.val(trim);
						};

						inputMake.val(make);
						inputModel.val(model);

						inputModelYear.val(modelYear);
						inputVin.val(vin);

						// selects
						vinYear.val(modelYear);

						let modelUrl = "/ajax/item/get-vehicle-entries-by-names?make=" + make + "&model=" + model;
						$.get(modelUrl, function(data) {
							/* console.log('------------------------------------');
							console.log(data);
							console.log("Brand: " + data.make.id);
							console.log("Model: " + data.model.id);
							console.log('------------------------------------'); */

							vinBrand.val(data.make.id);
							vinModel.val(data.model.id);

							// hidden inputs
							inputMake.val(data.make.id);
							inputModel.val(data.model.id);
						})
						.fail((response) => {
							console.error(response.responseJSON.message);
							spanError.show();
							successfully.hide();
							//Your vehicle is not defined
							spanMake.text('');
							spanModel.text('');
							spanModelYear.text('');
							vinNext.prop( "disabled", true );
						});

						/*setTimeout(() => {
							console.log('------------------------------------');
							console.log("Hidden: ");
							console.log(inputMake.val());
							console.log(inputModel.val());
							console.log(inputModelYear.val());
							console.log('------------------------------------');
							console.log("Selects: ");
							console.log(vinBrand.val());
							console.log(vinModel.val());
							console.log(vinYear.val());
							console.log('------------------------------------');
						}, 3000);*/

						if (trim2) {
							var trimArray = trim2.split(','),
								trimString = '';
							trimBlock.show();
							$.each(trimArray, function (i, v) {
								if (i == 0) { var c = 'checked' } else { var c = '' };
								trimString = trimString + '<input id="trim-' + v + '" name="trim" type="radio" value="trim" ' + c + '><label for="trim-' + v + '">' + v + '</label>\n'
								trimWrap.html(trimString);
							});
						};

						if (transmiss) {
							let regManual    = /manual/i;
							let regAutomatic = /automatic/i;

							console.log("Transmission: ", transmiss);

							let manualID = 38;
							let aunomaticID = 39;

							if(transmiss.match(regManual)) {
								toSelected(manualID);
							}
							else {
								if(transmiss.match(regAutomatic)) {
									toSelected(aunomaticID);
								}
							}

							function toSelected(value) {
								transSelect.children().each(function() {
									if( $(this).val() == value ) {
										$(this).prop("selected", true);
									} else {
										$(this).prop("selected", false);
									}
								});
							};

							/*function toSelected(reg) {
								transSelect.children().each(function() {
									if( $(this).text().match(reg) ) {
										$(this).prop("selected", true);
									} else {
										$(this).prop("selected", false);
									}
								});
							};*/
						};

						if (modelYear == "" && model == "" && make == "") {
							spanError.show();
							successfully.hide();
							//Your vehicle is not defined
							vinNext.prop( "disabled", true );
						} else {
							vinNext.prop( "disabled", false );
							if (make) { spanMake.html(make + '\u00A0') };
							if (modelYear) { spanModelYear.html(modelYear + '\u00A0') };
							if (model) { spanModel.html(model + '\u00A0') };
							spanError.hide();
							successfully.show();
						};

						spanVin.parent().show();
						spanVin.html(vinInp.val());
						
						vinAgree.slideDown();
						vinStep.slideUp();

						$(document).scrollTop($("header").height());
					},
					error: function (xhr, ajaxOptions, thrownError) {
						console.log(xhr.status);
						console.log(thrownError);
					}
				});
			};

		});

		$(vinBtnD).on('click', function() {
			vinBtn.click();
		});

		vinNext.on('click', function (e) {
			e.preventDefault();
			vinAgree.slideUp();
			form.slideDown();
			initMap();

			$(document).scrollTop($("header").height());
		});

		vinAgain.on('click', function (e) {
			e.preventDefault();
			spanError.hide();
			successfully.show();
			spanMake.text('');
			spanModel.text('');
			spanModelYear.text('');
			vinStep.slideDown();
			vinAgree.slideUp();
			vinBtn.children('img').hide();
			// clear fields
			vinYear.val('');
			vinBrand.val('');
			vinModel.val('');
			vinInp.val('');
			inputTrim2.val('');
			//vinFields.show();
		});

		vinNone.on("click", function(e) {
			e.preventDefault();
			vinFields.toggle(500);
		});
	},


	stepsFunc: function () {
		var form = $("#step-form form"),
			validSet = {
				errorElement: "span",
				errorClass: "form-error",
				errorPlacement: function (error, element) {
					error.appendTo(element.parent("div"));
				}
			};
		var index = 0;

		form.steps({
			headerTag: "h3",
			bodyTag: "section",
			transitionEffect: 1,
			titleTemplate: '<span class="sell__step-title">#title#</span>',
			labels: {
				cancel: "Cancel",
				current: "current step:",
				pagination: "Pagination",
				finish: "Finish",
				next: "Continue",
				previous: "Previous",
				loading: "Loading..."
			},
			onInit: function (event, currentIndex) {
				const newState = {step: currentIndex + 1};

				window.history.pushState(newState, '', `?step=${newState.step}`);
			},
			onStepChanging: function (event, currentIndex, newIndex) {
				if($("#step-form").hasClass("ready")) {
					return true;
				} else {
					if(currentIndex < newIndex) {
						form.validate(validSet).settings.ignore = ":disabled,:hidden";
						_init.prevStep();
						return form.valid();
					} else return true;
				}
			},
			onStepChanged: function(event, currentIndex, priorIndex) {
				const newState = {step: currentIndex + 1};

				if (window.history.state === null || window.history.state.step !== newState.step) {
					window.history.pushState(newState, '', `?step=${newState.step}`);
				}
			},
			onFinishing: function (event, currentIndex) {
				form.validate(validSet).settings.ignore = ":disabled";
				return form.valid();
			},
			onFinished: function (event, currentIndex) {
				form.submit();
			}
		});

		window.onpopstate = function(event) {
			if (!event.state) {
				return;
			}

			const step = event.state.step || null;

			if (step === null) {
				return;
			}

			/**
			 @description A hack to navigate to a specific step. setStep() method is not implemented in the jquery-steps library.
			 @see https://github.com/rstaib/jquery-steps/issues/5
			 */
			jQuery.each(form.data("steps"), function (indexInArray, valueOfElement) {
				if (valueOfElement.title != step) {
					return;
				}

				var currentIndex = form.steps("getCurrentIndex");
				var diferrence = indexInArray - currentIndex;

				for (var i = 0; i < diferrence; i++) {
					form.steps("next");
				}

				for (var i = 0; i > diferrence; i--) {
					form.steps("previous");
				}
			});
		};

		form.on('submit', function () {
			var $submitButton = form.find('.finish');

			if ($submitButton.length) {
				$submitButton.prop('disabled', true);
				$submitButton.prop('value', 'Submitting...');
			}
		})

		// Edit form
		if($("#step-form").hasClass("ready")) {
			$(".steps li").addClass("done");
			$(".steps li").removeClass("disabled");
			$(".steps li").attr("aria-disabled", "false");
			$(".steps li").attr("aria-selected", "false");
		}
	},

	buyItForm: function () {
		var $form = $('.buy-it-form');

		if ($form.length) {
			$form.on('submit', function() {
				var $submitButton = $form.find('button');

				if ($submitButton.length) {
					$submitButton.prop('disabled', true);
					$submitButton.html('Submitting...');
				}
			});
		}
	},
};




(function() {
	document.addEventListener("DOMContentLoaded", function() {
		makeRequired(document.querySelector("input[name=tires_rate]"));
		makeRequired(document.querySelector("input[name=brakes_rate]"));
		makeRequired(document.querySelector("input[name=paint_rate]"));
		makeRequired(document.querySelector("input[name=interior_rate]"));

		function makeRequired(elem) {
			if(elem) {
				elem.required = true;
				elem.setAttribute("style", "display: block; position: absolute; z-index: -1000; height: 0; font-size: 0; padding: 0; border: none;");
			}
		}
	});
})();



$(document).ready(_init.init);

// INIT MAP FUNCTION

function initMap() {
	var addessInput = document.getElementById('location_addr'),
		latInput    = document.getElementById('location_lat'),
		lngInput    = document.getElementById('location_lng'),
		zipInput    = document.getElementById("zip-input");

	var coord = { lat: 41.8781136, lng: -87.62979819999998 };

	addessInput.value;
	lngInput.value = coord.lng;
	latInput.value = coord.lat;

	var inputLat   = document.getElementById('pac-input'); // >>> addessInput
	
	var geocoder = new google.maps.Geocoder();

	/*geocoder.geocode({
		'latLng': coord
	}, function (results, status) {
		if (status == google.maps.GeocoderStatus.OK) {
			if (results[0]) {
				addessInput.value = results[0].formatted_address;
			}
		}
	});*/

	var map = new google.maps.Map(document.getElementById('map'), {
		center: coord,
		zoom: 4,
		disableDefaultUI: true,
		zoomControl: false,
		mapTypeControl: false,
		scaleControl: false,
		streetViewControl: false,
		rotateControl: false,
		fullscreenControl: false
	});

	var start = new google.maps.Marker({
		//position: coord,
		map: map
	});

	var markers = [];

	// Create the search box (autocomplete) and link it to the UI element.
	var input = document.getElementById('pac-input');
	var inputState = document.getElementById("location_state");
	var inputShort = document.getElementById("location_short");

	/* SEARCHBOX */
	/*var searchBox = new google.maps.places.SearchBox(input);
	map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
	// Bias the SearchBox results towards current map's viewport.
	map.addListener('bounds_changed', function () {
		searchBox.setBounds(map.getBounds());
	});
	// Listen for the event fired when the user selects a prediction and retrieve
	// more details for that place.
	searchBox.addListener('places_changed', function () {
		var places = searchBox.getPlaces();

		if (places.length == 0) {
			return;
		}

		// Clear out the old markers.
		markers.forEach(function (marker) {
			marker.setMap(null);
		});

		markers = [];

		// For each place, get the icon, name and location.
		var bounds = new google.maps.LatLngBounds();
		places.forEach(function (place) {

			start.setPosition(place.geometry.location);

			//TODO insert console in input

			addessInput.value = place.formatted_address;
			latInput.value = place.geometry.location.lat();
			lngInput.value = place.geometry.location.lng();

			if (place.geometry.viewport) {
				// Only geocodes have viewport.
				bounds.union(place.geometry.viewport);
			} else {
				bounds.extend(place.geometry.location);
			}
		});
		map.fitBounds(bounds);
	});*/


	// Autocomplete
	var countryRestrict = {'country': 'us'};
	var autocomplete = new google.maps.places.Autocomplete(input, {
		types: ['(regions)'],
        componentRestrictions: countryRestrict
	});

	map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
	autocomplete.bindTo('bounds', map);
	autocomplete.addListener('place_changed', onPlaceChanged);

	function onPlaceChanged() {
		var place = autocomplete.getPlace();

		// Clear out the old markers.
		markers.forEach(function (marker) {
			marker.setMap(null);
		});
		markers = [];

		// For each place, get the icon, name and location.
		var bounds = new google.maps.LatLngBounds();

		geoData(place.geometry.location);

		if (place.geometry.viewport) {
			// Only geocodes have viewport.
			bounds.union(place.geometry.viewport);
		} else {
			bounds.extend(place.geometry.location);
		}

		map.fitBounds(bounds);
	}


	// add address if click to map
	google.maps.event.addListener(map, 'click', function (event) {
		geoData(event.latLng);
	});

	// data for Back
	function geoData(LatLng) {
		start.setPosition(LatLng);
		geocoder.geocode({
			'latLng': LatLng
		}, function (results, status) {
			if (status == google.maps.GeocoderStatus.OK) {
				if (results[0]) {

					//TODO: insert console in input
					addessInput.value = results[0].formatted_address;
					zipInput.value = getZIP(results[0].address_components);
					latInput.value = results[0].geometry.location.lat();
					lngInput.value = results[0].geometry.location.lng();

					// fieal for ZIP is not required yet
					//input.required = false;
					input.value = getAddressString(results[0].address_components) || results[0].formatted_address;
				}
			}
		});
	}

	// create address string
	function getAddressString(addrObj) {
		var locality = "";
		var administrative_area = "";
		var postal_code = "";
		var country = "";

		var address = "";
		var short   = "";
		var data    = {
			0: "locality",
			1: "administrative_area_level_1",
			2: "postal_code",
			3: "country",

			key : "types",
			name: "short_name"
		}

		if(addrObj && typeof addrObj === "object") {
			for (const key in addrObj) {
				if (addrObj.hasOwnProperty(key)) {
					const element = addrObj[key];
					const types   = element[data.key];
					const name    = element[data.name];

					for (let i = 0; i < types.length; i++) {
						const type = types[i];
						
						switch (type) {
							case data[0]:
								locality = name;
								break;

							case data[1]:
								administrative_area = name;
								break;

							case data[2]:
								postal_code = name;
								break;

							case data[3]:
								country = name;
								break;
						
							default:
								break;
						}
					}
				}
			}
		}

		address = `${locality}, ${administrative_area} ${postal_code}` || false;
		short   = `${locality}, ${administrative_area}`                || false;

		if(inputState instanceof HTMLInputElement) inputState.value = administrative_area;
		if(inputShort instanceof HTMLInputElement) inputShort.value = short;

		return address;
	}

	// get ZIP from `address_components`
	function getZIP(components) {
		var zip = undefined;

		for (let i = 0; i < components.length; i++) {
			const addr = components[i];
			let type = "postal_code";

			for (let j = 0; j < addr.types.length; j++) {
				const t = addr.types[j];
				
				if(t === type) {
					zip = addr.long_name;
					break;
				}				
			}
		}

		return zip;
	}

	// only numbers in the autocomplite field
	if(input) input.addEventListener("keydown", function() {
		event = event || window.event;

		var code = event.keyCode;
		var key  = event.key;

		if( isNaN(key) && key !== "Backspace" && key !== "Delete" && key !== "ArrowLeft" && key !== "ArrowRight" ) 
			event.preventDefault();
	});
};


